/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getHome } from '../fn/operations/get-home';
import { GetHome$Params } from '../fn/operations/get-home';
import { VersionResponse } from '../models/version-response';

@Injectable({ providedIn: 'root' })
export class ApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getHome()` */
  static readonly GetHomePath = '/';

  /**
   * version.
   *
   * Prints the current version + meta data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getHome()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHome$Response(params?: GetHome$Params, context?: HttpContext): Observable<StrictHttpResponse<VersionResponse>> {
    return getHome(this.http, this.rootUrl, params, context);
  }

  /**
   * version.
   *
   * Prints the current version + meta data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getHome$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getHome(params?: GetHome$Params, context?: HttpContext): Observable<VersionResponse> {
    return this.getHome$Response(params, context).pipe(
      map((r: StrictHttpResponse<VersionResponse>): VersionResponse => r.body)
    );
  }

}
